module.exports = __webpack_public_path__ + "img/wp11.048ceb8b.jpeg";